import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './PromotionLearnMoreCard.module.css';

type PromotionLearnMoreCardProps = {
  bannerSource: string;
  title: string;
  link?: string;
  backgroundColor: string;
  titleColor: string;
  buttonColor: string;
} & PropsWithChildren;

export const PromotionLearnMoreCard = (props: PromotionLearnMoreCardProps) => {
  const {
    bannerSource,
    title,
    link,
    titleColor,
    backgroundColor,
    buttonColor,
    children,
  } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.cardContainer} style={{ backgroundColor }}>
      <img src={bannerSource} className={styles.imagePlaceholder} />
      <div className={styles.content}>
        <p className={styles.title} style={{ color: titleColor }}>
          {t(title)}
        </p>
        {children}
        {link ? (
          <a
            href={link}
            className={styles.button}
            style={{ backgroundColor: buttonColor }}
          >
            {t('Learn More')}
          </a>
        ) : null}
      </div>
    </div>
  );
};
